import { createSlice } from "@reduxjs/toolkit";
export enum SwapButonStates {
  CONNECT_TO_WALLET = "CONNECT_TO_WALLET",
  ENTER_AMOUNT = "ENTER_AMOUNT",
  APPROVE = "APPROVE",
  LOADING = "LOADING",
  SWAP = "SWAP",
  WRAP = "WRAP",
  INSUFFICIENT_BALANCE = "INSUFFICIENT_BALANCE",
  PRICE_IMPACT_TOO_HIGH = "PRICE_IMPACT_TOO_HIGH",
  SWITCH_CHAIN = "SWITCH_CHAIN",
  REFRESH_REQUEST = "REFRESH_REQUEST"
}
interface RouteState {
  value: {
    text: string;
    isDisable?: boolean;
    state: SwapButonStates;
  };
}
const initialState: RouteState = {
  value: {
    text: "",
    isDisable: false,
    state: null,
  },
};
export const swapbuttonSlice = createSlice({
  name: "route",
  initialState,
  reducers: {
    changeSwapButtonState: (state, action) => {
      state.value = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { changeSwapButtonState } = swapbuttonSlice.actions;

export default swapbuttonSlice.reducer;
